var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      on: {
        close: function($event) {
          _vm.$emit("close")
        }
      }
    },
    [
      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
        _c("h4", [_vm._v(_vm._s(_vm.lead.ref_id) + " - Voice message")])
      ]),
      _vm._v(" "),
      _c("div", { attrs: { slot: "body" }, slot: "body" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col" },
            [
              _c("div", { staticClass: "select-wrap h-auto" }, [
                _c("label", [_vm._v("Note")]),
                _vm._v(" "),
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.followUp.notes,
                      expression: "followUp.notes"
                    }
                  ],
                  staticClass: "select-wrap-textarea form-control",
                  attrs: {
                    name: "notes",
                    cols: "30",
                    rows: "10",
                    placeholder: "Enter your voice message notes"
                  },
                  domProps: { value: _vm.followUp.notes },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.followUp, "notes", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("error-field", {
                attrs: { errors: _vm.errors, field: "notes" }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col text-right" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    _vm.$emit("close")
                  }
                }
              },
              [_vm._v("\n          Cancel\n        ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary ld-ext-right",
                class: _vm.loadingButton ? "running" : "",
                attrs: { disabled: _vm.buttonDisabled },
                on: {
                  click: function($event) {
                    _vm.sendFollowUpVoice(_vm.lead.id)
                  }
                }
              },
              [
                _vm._v("\n          Send\n          "),
                _c("div", { staticClass: "ld ld-ball ld-flip" })
              ]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-606bea72", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-606bea72","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/leads/followUps/Voice.vue
// module id = null
// module chunks = 